/**
 * BreadcrumbSimple — minimal web3-style page header
 *
 * Single heading inside a dark glass container with green status dot.
 * Uses web3-style-guide tokens.
 *
 * @param {string} text1 - Heading text
 * @returns {React.ReactElement}
 */
export function BreadcrumbSimple({ text1 }: { text1: string }) {
  return (
    <div className="breadcrumb-simple">
      <span className="breadcrumb-logo" aria-hidden="true" />
      <h2>{text1}</h2>
    </div>
  );
}

/**
 * BreadcrumbModal — minimal modal-style header for modal contexts
 *
 * @param {string} text1 - Heading text
 * @returns {React.ReactElement}
 */
export function BreadcrumbModal({ text1 }: { text1: string }) {
  return (
    <div className="breadcrumb-modal">
      <h2>{text1}</h2>
    </div>
  );
}

export default BreadcrumbSimple;
